import { css } from 'reakit/styled';
import { theme, palette } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import { tint } from 'polished';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
var sizeAttributes = {
  small: css(["height:0.6rem;&{", ";}"], theme('fannypack.ProgressBar.sizes.small')),
  default: css(["&{", ";}"], theme('fannypack.ProgressBar.sizes.default')),
  medium: css(["height:1.5rem;&{", ";}"], theme('fannypack.ProgressBar.sizes.medium')),
  large: css(["height:2rem;&{", ";}"], theme('fannypack.ProgressBar.sizes.large'))
};
var ProgressBarIndicator = styled(Box).withConfig({
  displayName: "styled__ProgressBarIndicator",
  componentId: "sc-17o5xqx-0"
})(["height:100%;background-color:", ";transition:width 300ms cubic-bezier(0.4,0,0.2,1) 0ms;width:", "%;&{", ";}"], function (props) {
  return palette(props.color, props.color);
}, function (props) {
  return props.value || '0';
}, theme('fannypack.ProgressBar.indicator'));
var ProgressBar = styled(Box).withConfig({
  displayName: "styled__ProgressBar",
  componentId: "sc-17o5xqx-1"
})(["border-radius:3px;overflow:hidden;width:100%;height:1rem;background-color:", ";", " &{", ";}"], function (props) {
  return tint(0.9, palette(props.color, props.color)(props));
}, function (props) {
  return props.styledSize && sizeAttributes[props.styledSize || ''];
}, theme('fannypack.ProgressBar.base'));
export default ProgressBar;
export { ProgressBar, ProgressBarIndicator };